const moveFilters = () => {
  if(window.innerWidth < 992) return;
  const categoryTop = document.querySelector(".category-content-wrapper");
  const filtersWrapper = categoryTop.querySelector("#filters-wrapper");
  if (!filtersWrapper) return;
  const sideFilters = document.querySelector("#category-filter-hover");
  if (!sideFilters) return;
  filtersWrapper.prepend(sideFilters);
  const sideBar = document.querySelector(".box-filters");
  if (!sideBar) return;
  const sideBarFilterWrapper = sideBar.querySelector("#filters");
  if (!sideBarFilterWrapper) return;
  const manufacturersFilter = document.querySelector("#manufacturer-filter");
  if (!manufacturersFilter) return;
  sideBarFilterWrapper.appendChild(manufacturersFilter);
};
export { moveFilters };
